<template>
    <div class="wrap clear_a">
        <div class="page-tilt">
            <b></b>
            <span>AI摄像头预警详情</span>
        </div>
        <div class="user-box">
            <div class="table">
                <el-table v-loading="loading" element-loading-text="数据正在努力加载中" :border="true" :resizable="true" :data="tableData" class="table-div">
                    <!-- <el-table-column type="selection" label="" width="50"></el-table-column> -->
                    <el-table-column show-overflow-tooltip prop="pdtName" min-width="190" label="异常类型">
                        <template slot-scope="scope">{{warning[scope.row.warningType]}}</template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="warningDate" min-width="150" label="预警时间">
                    </el-table-column>
                    <el-table-column prop="screenshotUrl" min-width="100" label="异常截图">
                        <template slot-scope="scope">
                            <el-image style="width: 100px; height: 100px" :src="scope.row.screenshots" :preview-src-list="[scope.row.screenshots]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="cameraPosition" min-width="100" label="摄像头点位名称">
                    </el-table-column>
                </el-table>
                <div class="pagination-box">
                    <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange" :current-page="tableLimit.current"
                                   :page-sizes="[10, 20, 30, 40,50]" :page-size="tableLimit.size" layout="total, sizes, prev, pager, next, jumper"
                                   :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template> 

<script>
import * as api from 'api/warning_v2.js';

export default {
    data() {
        return {
            warningType: "0202",
            page: {
                total: 0
            },
            schoolTraceBaseUrl: '',
            loading: false,
            tableData: [],
            tableLimit: {
                entityId: '',
                warningType: '',
                current: 1,
                size: 10,
                warningDate: ''
            },
            warning: {},
        };
    },
    async mounted() {
        this.tableLimit.entityId = this.$store.state.common.user.deptId;
        this.tableLimit.warningDate = this.$route.query.ewDate;
        this.tableLimit.warningType = this.$route.query.ewType;
        this.schoolTraceBaseUrl = this.$store.state.common.baseUrl;
        this.searchTab();

        // 获取 异常类型
        api.getType({ parentCode: this.warningType })
            .then(data => {
                if (data.code == 200) {
                    this.warning = data.data;
                    this.warning = this.array2Object(this.warning);
                }
            });
    },
    methods: {
        async searchPage() {
            this.loading = true;
            let result = await api.getAIDetail(this.tableLimit)
            if (result.code == 200) {
                this.tableData = result.data.records;
                this.page.total = result.data.total
            } else {
                this.$message.warning(result.message);
            }
            this.loading = false;
        },
        searchTab() {
            this.tableLimit.current = 1;
            this.searchPage();
        },
        pageCurrentChange(num) {
            this.tableLimit.current = num;
            this.searchPage();
        },
        pageSizeChange(size) {
            this.tableLimit.size = size;
            this.searchPage();
        },
        // [{value: '', key: ''}] => {key: value}
        array2Object(arr = []) {
            let obj = {};

            arr.forEach(item => {
                obj[item.key] = item.value;
            })

            return obj;
        },
    }
};
</script>
<style scoped lang="scss">
.wrap {
    width: calc(100% - 60px);
    padding: 20px 30px;
    min-height: calc(100% - 125px);
    background: #fff;
    border-radius: 10px;
    margin-bottom: 30px;
}
.ipt-btn-box {
    margin: 20px 0;


    span {
        line-height: 33px;
    }
}
.pagination-box {
    text-align: right;
    margin-top: 20px;
}
.table-div {
    margin-top: 20px;
    width: 100%;
    text-align: center;
}
.operate-a {
    color: #1787ad;
}
table tr td:last-child .cell a {
    border-right: 1px solid #ccc;
    padding-right: 5px;
}
table tr td:last-child .cell a:last-child {
    border-right: none;
    padding-right: 0px;
}
</style>
